import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
// Import environment config file.
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { AjaxResponseInterface } from 'src/app/interface/global/AjaxResponseInterface';

@Injectable({
  providedIn: 'root'
})
export class CustomFieldModelService {

  // Define the class property.
  private customBaseUrl: string = environment.apiUrl + '/custom-field';
  constructor(
    private http: HttpClient
  ) { }

  /**
   * this user service is used to add new custom fields.
   * @param bodyParams: any
   */
  addCustomFields(bodyParams: any): Observable<any> {
    return this.http.post<any>(this.customBaseUrl, bodyParams).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  /**
   * this user service is used to get custom fields list.
   * @param qObj: any
   */
  getCustomFieldList(qObj: any): Observable<any> {
    return this.http.get<any>(this.customBaseUrl, { params: qObj }).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  /**
   * this user service is used to counts custom fields.
   * @param qObj: any
   */
  getCustomFieldCounts(qObj: any): Observable<any> {
    return this.http.get<any>(this.customBaseUrl + '/custom-field-count', { params: qObj }).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  /**
   * this user service is used to update custom filed.
   * @param queryObj: any
   */
  updateCustomFiled(queryObj: string, bodyParams: any): Observable<AjaxResponseInterface<[]>> {
    return this.http.post<AjaxResponseInterface<[]>>(this.customBaseUrl + '/update-custom-field?_id=' + queryObj, bodyParams).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
  getUniqueCustomField(qObj:{ [key: string]: string}, thisRef: CustomFieldModelService = this): Observable<AjaxResponseInterface<string>> {
    return thisRef.http.get<AjaxResponseInterface<string>>(thisRef.customBaseUrl + "/unique-custom-field", {
      params: qObj,
    });
  }

}
